import classNames from 'classnames';
import { Html5QrcodeScanner } from 'html5-qrcode';
import { useEffect, useId } from 'react';

const BarcodeScanner = ({
  onScanSuccess,
  className,
}: {
  onScanSuccess: (decodedText: string, decodedResult: any) => void;
  className?: string;
}) => {
  const id = useId();
  useEffect(() => {
    const html5QrcodeScanner = new Html5QrcodeScanner(
      id,
      { fps: 10, qrbox: { width: 250, height: 250 } },
      false,
    );
    html5QrcodeScanner.render(onScanSuccess, undefined);

    return () => {
      html5QrcodeScanner.clear();
    };
  }, [onScanSuccess, id]);

  return <div id={id} className={classNames(className)} />;
};

export default BarcodeScanner;
